<div class="deal-type-header">
  <span class="deal-type-header__title">Current Deal - Entry Method</span>
  <button mat-icon-button mat-dialog-close class="deal-type-header__close">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <!-- ═══ Phase 1: Card Selection ═══ -->
  @if (phase() === 'select') {
    <div class="entry-method-cards">
      <button class="entry-method-card" (click)="selectUploadTermSheet()">
        <svg
          class="entry-method-card__icon"
          viewBox="0 0 64 64"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M12 4 H42 L52 14 V58 Q52 60 50 60 H14 Q12 60 12 58 Z"
            fill="#e8dfd3" />
          <path d="M42 4 V14 H52 Z" fill="#d4cabb" />
          <rect x="18" y="22" width="28" height="2.5" rx="1" fill="#c4b9a8" />
          <rect x="18" y="29" width="22" height="2.5" rx="1" fill="#c4b9a8" />
          <rect x="18" y="36" width="26" height="2.5" rx="1" fill="#c4b9a8" />
          <rect x="18" y="43" width="18" height="2.5" rx="1" fill="#c4b9a8" />
          <rect x="18" y="50" width="24" height="2.5" rx="1" fill="#c4b9a8" />
        </svg>
        <span class="entry-method-card__title">Upload Term Sheet</span>
        <span class="entry-method-card__description"
          >AI extracts deal fields automatically</span
        >
        <span class="entry-method-card__badge">AI-powered</span>
      </button>

      <button class="entry-method-card" (click)="selectManualEntry()">
        <svg
          class="entry-method-card__icon"
          viewBox="0 0 64 64"
          xmlns="http://www.w3.org/2000/svg">
          <g transform="rotate(-45 32 32)">
            <rect x="28" y="4" width="8" height="4" rx="0.5" fill="#4caf50" />
            <rect x="28" y="0" width="8" height="5" rx="2" fill="#ef9a9a" />
            <rect x="28" y="8" width="8" height="3" fill="#bdbdbd" />
            <rect x="28" y="11" width="8" height="36" fill="#fdd835" />
            <polygon points="28,47 36,47 32,58" fill="#e8c76a" />
            <polygon points="30.5,53 33.5,53 32,58" fill="#424242" />
          </g>
        </svg>
        <span class="entry-method-card__title">Manual Entry</span>
        <span class="entry-method-card__description"
          >Fill out the deal form</span
        >
      </button>
    </div>
  }

  <!-- ═══ Phase 2: File Upload ═══ -->
  @if (phase() === 'upload') {
    <div
      class="upload-zone"
      [class.upload-zone--drag-over]="dragCounter > 0"
      (drop)="handleDrop($event)"
      (dragenter)="dragEnter($event)"
      (dragleave)="dragLeave($event)"
      (dragover)="dragOver($event)">
      <mat-icon class="upload-zone__icon">cloud_upload</mat-icon>
      <p class="upload-zone__title">Drag & drop your term sheet here</p>
      <p class="upload-zone__subtitle">or</p>
      <button type="button" mat-stroked-button (click)="fileInput.click()">
        Browse Files
      </button>
      <input
        #fileInput
        type="file"
        accept=".pdf,application/pdf"
        hidden
        (change)="onFileInputChange($event)" />
      <p class="upload-zone__hint">Supported format: PDF</p>
    </div>

    @if (uploadError()) {
      <div class="upload-error">
        <mat-icon>error_outline</mat-icon>
        <span
          >We couldn't read this document. Please try another term sheet or use
          manual entry.</span
        >
      </div>
    }
  }

  <!-- ═══ Phase 3: Processing ═══ -->
  @if (phase() === 'processing') {
    <div class="processing-state">
      <mat-spinner diameter="48"></mat-spinner>
      <p class="processing-state__file">{{ fileList[0]?.name }}</p>
      <p class="processing-state__message">
        {{ currentUploadMessage$ | async }}
      </p>
      <p class="processing-state__hint">
        This may take a couple minutes for larger documents
      </p>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions>
  @if (phase() !== 'processing') {
    <button type="button" mat-stroked-button (click)="goBack()">
      <mat-icon>arrow_back</mat-icon>
      Back
    </button>
  }
</mat-dialog-actions>
